module.exports = __webpack_public_path__ + "media/images/log/log-graph-icon-107e7f6f4fa0ee29d6b2bb34a1170cfa.svg";